<template>
  <MobileContainer>
    <MobileHeader slot="header"
                  :close-to="backPage"
                  :nav-action="navAction">
      Confirm Payment
    </MobileHeader>

    <CheckoutPayment/>

  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import MobileButton from '@/apps/mobile/components/MobileButton';
import CheckoutPayment from '@/components/CheckoutPayment';

/**
 * Mobile payment confirm.
 */
@Component({
  components: {
    MobileButton,
    MobileHeader,
    MobileContainer,
    CheckoutPayment,
  },
  props: {
    backPage: {
      type:    [ Object, String ],
      default: null,
    },
  },
})
export default class MobilePaymentConfirm extends Vue {
  get navAction() {
    return this.backPage ? 'close' : 'back';
  }
}
</script>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobilePaymentConfirm.vue